import lang from "../data/lang.json";

export const getLang = (slug) => {
  return lang[slug] ?? slug;
};
